import styled from "styled-components";
import ExpandableContent from "@streeteasy/design-system/legacy/ExpandableContent";

import { largeScreen } from "src/shared/constants/screenSizes";

const ChooseDateTimeContainer = styled.div`
  display: grid;
  grid-gap: 2vw;
  grid-template-columns: 2fr 2fr 1fr;
  grid-template-rows: 1fr;
  margin-bottom: 15px;
  width: 100%;
  @media (min-width: ${largeScreen}px) {
    grid-gap: 0.5vw;
  }

  .fa-angle-down {
    font-family: FontAwesome !important;
  }
`;

const DateTimeAddButton = styled(ExpandableContent)`
  padding: 9px;
`;

ChooseDateTimeContainer.displayName = "ChooseDateTimeContainer";
DateTimeAddButton.displayName = "DateTimeAddButton";

export { ChooseDateTimeContainer, DateTimeAddButton };
